import React from 'react'
import {
  getOperations,
  getPrices,
  getEnvironment,
  getRooms,
  getAge,
  hasBarbacue,
  hasPool,
  getToilets,
  getBathrooms,
  hasTag,
} from '@helpers/helper.properties'
import FeaturedSVG from './featured.svg'
import { Property } from 'types'

export const Separator = (
  el1: any,
  el2: any,
  el3: any,
  title: string,
  atribute?: { name: string; id: number }[],
): {} => {
  const check = () => {
    if (!el1?.id || title === 'Información básica') {
      return true
    }
    switch (title) {
      case 'Generales':
        if (
          atribute?.find((element) => hasTag(el1, element.id)) ||
          atribute?.find((element) => hasTag(el2, element.id)) ||
          atribute?.find((element) => hasTag(el3, element.id))
        )
          return true
        return false
      case 'Servicios':
        if (
          atribute?.find((element) => hasTag(el1, element.id)) ||
          atribute?.find((element) => hasTag(el2, element.id)) ||
          atribute?.find((element) => hasTag(el3, element.id))
        )
          return true
        return false
      case 'Tipos de ambientes':
        if (
          atribute?.find((element) => hasTag(el1, element.id)) ||
          atribute?.find((element) => hasTag(el2, element.id)) ||
          atribute?.find((element) => hasTag(el3, element.id))
        )
          return true
        return false
      case 'Superficies':
        if (
          el1?.surface !== '0.00' ||
          el1?.semiroofed_surface !== '0.00' ||
          el1?.total_surface !== '0.00' ||
          el1?.unroofed_surface !== '0.00' ||
          el1?.roofed_surface !== '0.00'
        ) {
          return true
        }
        if (
          el2?.surface !== '0.00' ||
          el2?.semiroofed_surface !== '0.00' ||
          el2?.total_surface !== '0.00' ||
          el2?.unroofed_surface !== '0.00' ||
          el2?.roofed_surface !== '0.00'
        ) {
          return true
        }
        if (
          el3?.surface !== '0.00' ||
          el3?.semiroofed_surface !== '0.00' ||
          el2?.total_surface !== '0.00' ||
          el2?.unroofed_surface !== '0.00' ||
          el2?.roofed_surface !== '0.00'
        ) {
          return true
        }
        return false
    }
    return false
  }

  return check() ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-best-option">
        <th
          colSpan={2}
          className="text-center"
        >
          {title}
        </th>
      </tr>
      <tr className="tr-d-best-option separator">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          {title}
        </th>
        <td style={{ borderRight: 'none' }}>{<p></p>}</td>
        <td style={{ borderRight: 'none' }}></td>
        <td
          style={{ borderRight: 'none' }}
          className={'d-none d-lg-table-cell'}
        ></td>
      </tr>
    </>
  ) : (
    ''
  )
}

export const FeaturedTr = (el1: any, el2: any, el3: any, points: any) => {
  return (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-best-option">
        <th
          colSpan={2}
          className="text-center"
        >
          Mejor opción
        </th>
      </tr>
      <tr className="tr-d-best-option">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Mejor opción
        </th>
        <td className={Math.max(...points) === points[0] && el1?.id && el2?.id && 'featured-cell'}>
          {
            <p>
              <img
                src={FeaturedSVG}
                className="main-featured-icon"
                alt=""
              />
              <span className="featured-text">{el1?.id ? points[0] : '-'}</span>
            </p>
          }
        </td>
        <td className={Math.max(...points) === points[1] && el1?.id && el2?.id && 'featured-cell'}>
          {el1?.id && (
            <p>
              <img
                src={FeaturedSVG}
                className="main-featured-icon"
              />
              <span className="featured-text">{el2?.id ? points[1] : el1?.id ? '-' : ''}</span>
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell ' +
            (Math.max(...points) === points[2] && el1?.id && el2?.id && 'featured-cell')
          }
        >
          {el2?.id && (
            <p>
              <img
                src={FeaturedSVG}
                className="main-featured-icon"
              />
              <span className="featured-text">{el3?.id ? points[2] : '-'}</span>
            </p>
          )}
        </td>
      </tr>
    </>
  )
}

export const OperationTypeTr = (el1: any, el2: any, el3: any) => {
  return (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-operation-type">
        <th
          colSpan={2}
          className="text-center"
        >
          Operación
        </th>
      </tr>
      <tr className="tr-d-operation-type">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Operación
        </th>
        <td className="position-relative first-column">
          <p>
            {el1?.id ? getOperations(el1).map((op) => <span className="item">{op}</span>) : '-'}
          </p>
        </td>
        <td className="position-relative">
          <p>
            {el2?.id
              ? getOperations(el2).map((op) => <span className="item">{op}</span>)
              : el1?.id
              ? '-'
              : ''}
          </p>
        </td>
        <td className={'d-none d-lg-table-cell ' + 'position-relative'}>
          <p>
            {el3?.id
              ? getOperations(el3).map((op) => <span className="item">{op}</span>)
              : el2?.id
              ? '-'
              : ''}
          </p>
        </td>
      </tr>
    </>
  )
}

export const PriceTrVenta = (el1: any, el2: any, el3: any, price: any) => {
  const max = price
  const disabled =
    (getPrices(el1).filter((element) => element?.type.toLowerCase() === 'venta') ===
      getPrices(el2).filter((element) => element?.type.toLowerCase() === 'venta') &&
      getPrices(el1).filter((element) => element?.type.toLowerCase() === 'venta') ===
        getPrices(el3).filter((element) => element?.type.toLowerCase() === 'venta')) ||
    !el2

  return (
    <>
      {!el1?.id ||
      getPrices(el1).find((element) => element?.type === 'Venta')?.price ||
      getPrices(el2).find((element) => element?.type === 'Venta')?.price ||
      getPrices(el3).find((element) => element?.type === 'Venta')?.price ? (
        <>
          <tr className="d-xs-table-row d-sm-none tr-m-price">
            <th
              colSpan={2}
              className="text-center"
            >
              Valor venta
            </th>
          </tr>
          <tr className="tr-d-price">
            <th
              scope="row"
              className="d-none d-sm-table-cell first-cell"
            >
              Valor venta
            </th>
            <td
              className={
                'position-relative first-column' +
                (!disabled &&
                max === getPrices(el1).find((element) => element?.type === 'Venta')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el1).find((element) => element?.type === 'Venta')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el1?.id &&
              getPrices(el1).filter((element) => element?.type.toLowerCase() === 'venta').length > 0
                ? getPrices(el1)
                    .filter((element) => element?.type.toLowerCase() === 'venta')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price!.toString()) > 0
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : '-'}
            </td>
            <td
              className={
                'position-relative' +
                (!disabled &&
                max === getPrices(el2).find((element) => element?.type === 'Venta')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el2).find((element) => element?.type === 'Venta')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el2?.id &&
              el1?.id &&
              getPrices(el2).filter((element) => element?.type.toLowerCase() === 'venta').length > 0
                ? getPrices(el2)
                    .filter((element) => element?.type.toLowerCase() === 'venta')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el2?.id && el1?.id) ||
                  (getPrices(el2)?.filter((element) => element?.type.toLowerCase() === 'venta')
                    .length === 0 &&
                    el1?.id)
                ? '-'
                : ''}
            </td>
            <td
              className={
                'd-none d-lg-table-cell' +
                ' position-relative' +
                (!disabled &&
                max === getPrices(el3).find((element) => element?.type === 'Venta')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el3).find((element) => element?.type === 'Venta')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el3?.id &&
              el2?.id &&
              getPrices(el3).filter((element) => element?.type.toLowerCase() === 'venta').length > 0
                ? getPrices(el3)
                    .filter((element) => element?.type.toLowerCase() === 'venta')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price?.toString()!) > 0
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el3?.id && el2?.id) ||
                  (getPrices(el3)?.filter((element) => element?.type.toLowerCase() === 'venta')
                    .length === 0 &&
                    el2?.id)
                ? '-'
                : ''}
            </td>
          </tr>
        </>
      ) : (
        ''
      )}
      {/* {(!el1?.id) || getPrices(el1).find((element) => element?.type === 'Alquiler')?.price || getPrices(el2).find((element) => element?.type === 'Alquiler')?.price || getPrices(el3).find((element) => element?.type === 'Alquiler')?.price
        ?   <>
                <tr className="d-xs-table-row d-sm-none tr-m-price">
                    <th colSpan={2} className="text-center">Valor alquiler</th>
                </tr>
                <tr className="tr-d-price">
                    <th scope="row" className="d-none d-sm-table-cell first-cell">Valor alquiler</th>
                    <td className="position-relative">
                        { max === getPrices(el1)[0]?.price && <FeaturedSvg className="featured-icon"/> }
                        {el1?.id && getPrices(el1).filter(element => element?.type.toLowerCase() === 'alquiler').length > 0
                            ? getPrices(el1).filter(element => element?.type.toLowerCase() === 'alquiler').map((price, index) => (
                                <p className={"prop-price me-3 mb-0 " + price.type + ` ${price.price === "Precio a consultar" ? 'uninformed' : ''}`} key={index}> {price.price === "Precio a consultar" ? price.price : price.currency + (parseInt(price.price?.toString()!) ? Intl.NumberFormat("de-DE").format(parseInt(price.price?.toString()!)) : '-')}</p>
                            ))
                            : '-'
                        }
                    </td>
                    <td className="position-relative">
                        { max === getPrices(el2)[0]?.price && <FeaturedSvg className="featured-icon"/> }
                        {el2?.id && el1?.id && getPrices(el2).filter(element => element?.type.toLowerCase() === 'alquiler').length > 0
                            ? getPrices(el2).filter(element => element?.type.toLowerCase() === 'alquiler').map((price, index) => (
                                <p className={"prop-price me-3 mb-0 " + price.type + ` ${price.price === "Precio a consultar" ? 'uninformed' : ''}`} key={index}>{price.price === "Precio a consultar" ? price.price : price.currency + (parseInt(price.price?.toString()!) ? Intl.NumberFormat("de-DE").format(parseInt(price.price?.toString()!)) : '-')}</p>
                            ))
                            :   ((!el2?.id && el1?.id) || (getPrices(el2).filter(element => element?.type.toLowerCase() === 'alquiler').length === 0) ? '-' : '')
                        }
                    </td>
                    <td className={'d-none d-lg-table-cell'  + " position-relative"}>
                        { max === getPrices(el3)[0]?.price && <FeaturedSvg className="featured-icon"/> }
                        {el3?.id && el2?.id && getPrices(el3).filter(element => element?.type.toLowerCase() === 'alquiler').length > 0
                            ? getPrices(el3).filter(element => element?.type.toLowerCase() === 'alquiler').map((price, index) => (
                                <p className={"prop-price me-3 mb-0 " + price.type + ` ${price.price === "Precio a consultar" ? 'uninformed' : ''}`} key={index}>{price.price === "Precio a consultar" ? price.price : price.currency + (parseInt(price.price?.toString()!) ? Intl.NumberFormat("de-DE").format(parseInt(price.price?.toString()!)) : '-')}</p>
                            ))
                            :   ((!el3?.id && el2?.id) || (getPrices(el3).filter(element => element?.type.toLowerCase() === 'alquiler').length === 0) ? '-' : '')
                        }
                    </td>
                </tr>
            </>
        :''} */}
    </>
  )
}

export const PriceTrAlquiler = (el1: any, el2: any, el3: any, price: any) => {
  const max = price
  const disabled =
    (getPrices(el1).filter((element) => element?.type.toLowerCase() === 'alquiler') ===
      getPrices(el2).filter((element) => element?.type.toLowerCase() === 'alquiler') &&
      getPrices(el1).filter((element) => element?.type.toLowerCase() === 'alquiler') ===
        getPrices(el3).filter((element) => element?.type.toLowerCase() === 'alquiler')) ||
    !el2

  return (
    <>
      {!el1?.id ||
      getPrices(el1).find((element) => element?.type === 'Alquiler')?.price ||
      getPrices(el2).find((element) => element?.type === 'Alquiler')?.price ||
      getPrices(el3).find((element) => element?.type === 'Alquiler')?.price ? (
        <>
          <tr className="d-xs-table-row d-sm-none tr-m-price">
            <th
              colSpan={2}
              className="text-center"
            >
              Valor alquiler
            </th>
          </tr>
          <tr className="tr-d-price">
            <th
              scope="row"
              className="d-none d-sm-table-cell first-cell"
            >
              Valor alquiler
            </th>
            <td
              className={
                'position-relative first-column' +
                (!disabled &&
                max === getPrices(el1).find((element) => element?.type === 'Alquiler')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el1).find((element) => element?.type === 'Alquiler')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el1?.id &&
              getPrices(el1).filter((element) => element?.type.toLowerCase() === 'alquiler')
                .length > 0
                ? getPrices(el1)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {' '}
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price?.toString()!) > 0
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : '-'}
            </td>
            <td
              className={
                'position-relative' +
                (!disabled &&
                max === getPrices(el2).find((element) => element?.type === 'Alquiler')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el2).find((element) => element?.type === 'Alquiler')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el2?.id &&
              el1?.id &&
              getPrices(el2).filter((element) => element?.type.toLowerCase() === 'alquiler')
                .length > 0
                ? getPrices(el2)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el2?.id && el1?.id) ||
                  (getPrices(el2).filter((element) => element?.type.toLowerCase() === 'alquiler')
                    .length === 0 &&
                    el1?.id)
                ? '-'
                : ''}
            </td>
            <td
              className={
                'd-none d-lg-table-cell' +
                ' position-relative' +
                (!disabled &&
                max === getPrices(el3).find((element) => element?.type === 'Alquiler')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max === getPrices(el3).find((element) => element?.type === 'Alquiler')?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el3?.id &&
              el2?.id &&
              getPrices(el3).filter((element) => element?.type.toLowerCase() === 'alquiler')
                .length > 0
                ? getPrices(el3)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            ' ' +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el3?.id && el2?.id) ||
                  (getPrices(el3).filter((element) => element?.type.toLowerCase() === 'alquiler')
                    .length === 0 &&
                    el2?.id)
                ? '-'
                : ''}
            </td>
          </tr>
        </>
      ) : (
        ''
      )}
    </>
  )
}

export const PriceTrAlquilerTemp = (el1: any, el2: any, el3: any, price: any) => {
  const max = price
  const disabled =
    (getPrices(el1).filter((element) => element?.type === 'Alquiler temporario') ===
      getPrices(el2).filter((element) => element?.type === 'Alquiler temporario') &&
      getPrices(el1).filter((element) => element?.type === 'Alquiler temporario') ===
        getPrices(el3).filter((element) => element?.type === 'venta')) ||
    !el2

  return (
    <>
      {!el1?.id ||
      getPrices(el1).find((element) => element?.type === 'Alquiler temporario')?.price ||
      getPrices(el2).find((element) => element?.type === 'Alquiler temporario')?.price ||
      getPrices(el3).find((element) => element?.type === 'Alquiler temporario')?.price ? (
        <>
          <tr className="d-xs-table-row d-sm-none tr-m-price">
            <th
              colSpan={2}
              className="text-center"
            >
              Valor alquiler temporario
            </th>
          </tr>
          <tr className="tr-d-price">
            <th
              scope="row"
              className="d-none d-sm-table-cell first-cell"
            >
              Valor alquiler temporario
            </th>
            <td
              className={
                'position-relative first-column' +
                (!disabled &&
                max ===
                  getPrices(el1).find((element) => element?.type === 'Alquiler temporario')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max ===
                  getPrices(el1).find((element) => element?.type === 'Alquiler temporario')
                    ?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el1?.id &&
              getPrices(el1).filter(
                (element) => element?.type.toLowerCase() === 'alquiler temporario',
              ).length > 0
                ? getPrices(el1)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler temporario')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {' '}
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : '-'}
            </td>
            <td
              className={
                'position-relative' +
                (!disabled &&
                max ===
                  getPrices(el2).find((element) => element?.type === 'Alquiler temporario')?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max ===
                  getPrices(el2).find((element) => element?.type === 'Alquiler temporario')
                    ?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el2?.id &&
              el1?.id &&
              getPrices(el2).filter(
                (element) => element?.type.toLowerCase() === 'alquiler temporario',
              ).length > 0
                ? getPrices(el2)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler temporario')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el2?.id && el1?.id) ||
                  (getPrices(el2).filter(
                    (element) => element?.type.toLowerCase() === 'alquiler temporario',
                  ).length === 0 &&
                    el1?.id)
                ? '-'
                : ''}
            </td>
            <td
              className={
                'd-none d-lg-table-cell' +
                ' position-relative' +
                (!disabled &&
                max ===
                  getPrices(el3).find(
                    (element) => element?.type.toLowerCase() === 'alquiler temporario',
                  )?.price
                  ? ' featured-cell-print'
                  : '')
              }
            >
              {!disabled &&
                max ===
                  getPrices(el3).find(
                    (element) => element?.type.toLowerCase() === 'alquiler temporario',
                  )?.price && (
                  <img
                    className="featured-icon"
                    src={FeaturedSVG}
                  />
                )}
              {el3?.id &&
              el2?.id &&
              getPrices(el3).filter(
                (element) => element?.type.toLowerCase() === 'alquiler temporario',
              ).length > 0
                ? getPrices(el3)
                    .filter((element) => element?.type.toLowerCase() === 'alquiler temporario')
                    .map((price, index) => (
                      <p
                        className={
                          'prop-price me-3 mb-0 ' +
                          price.type +
                          ` ${price.price === 'Precio a consultar' ? 'uninformed' : ''}`
                        }
                        key={index}
                      >
                        {price.price === 'Precio a consultar'
                          ? price.price
                          : price.currency +
                            (parseInt(price.price?.toString()!)
                              ? Intl.NumberFormat('de-DE').format(
                                  parseInt(price.price?.toString()!),
                                )
                              : '-')}
                      </p>
                    ))
                : (!el3?.id && el2?.id) ||
                  (getPrices(el3).filter(
                    (element) => element?.type.toLowerCase() === 'alquiler temporario',
                  ).length === 0 &&
                    el2?.id)
                ? '-'
                : ''}
            </td>
          </tr>
        </>
      ) : (
        ''
      )}
    </>
  )
}

export const ExpensesTr = (el1: any, el2: any, el3: any, espenses = 0) => {
  const max = espenses
  return (
    <>
      {!el1?.id || el1?.expenses || el2?.expenses || el3?.expenses ? (
        <>
          <tr className="d-xs-table-row d-sm-none tr-m-price">
            <th
              colSpan={2}
              className="text-center"
            >
              Expensas
            </th>
          </tr>
          <tr className="tr-d-price">
            <th
              scope="row"
              className="d-none d-sm-table-cell first-cell"
            >
              Expensas
            </th>
            <td
              className={
                'position-relative first-column' +
                (max === el1?.expenses ? ' featured-cell-print' : '')
              }
            >
              {max === el1?.expenses && (
                <img
                  className="featured-icon"
                  src={FeaturedSVG}
                />
              )}
              {el1?.id ? (
                <p>
                  {el1?.expenses ? 'ARS ' + Intl.NumberFormat('de-DE').format(el1?.expenses) : '-'}
                </p>
              ) : (
                '-'
              )}
            </td>
            <td
              className={
                'position-relative' + (max === el2?.expenses ? ' featured-cell-print' : '')
              }
            >
              {max === el2?.expenses && (
                <img
                  className="featured-icon"
                  src={FeaturedSVG}
                />
              )}
              {el2?.id && el1?.id ? (
                <p>
                  {el2?.expenses ? 'ARS ' + Intl.NumberFormat('de-DE').format(el2?.expenses) : '-'}
                </p>
              ) : !el2?.id && el1?.id ? (
                '-'
              ) : (
                ''
              )}
            </td>
            <td
              className={
                'd-none d-lg-table-cell' +
                ' position-relative' +
                (max === el3?.expenses ? ' featured-cell-print' : '')
              }
            >
              {max === el3?.expenses && (
                <img
                  className="featured-icon"
                  src={FeaturedSVG}
                />
              )}
              {!el3?.id && el2?.id ? (
                <p>
                  {el3?.expenses ? 'ARS ' + Intl.NumberFormat('de-DE').format(el3?.expenses) : '-'}
                </p>
              ) : !el3?.id && el2?.id ? (
                '-'
              ) : (
                ''
              )}
            </td>
          </tr>
        </>
      ) : (
        ''
      )}
    </>
  )
}

export const TotalSurfaceTr = (el1: any, el2: any, el3: any, total: any) => {
  const max = total
  const disabled =
    (el1?.total_surface === el2?.total_surface && el1?.total_surface === el3?.total_surface) ||
    !el2?.total_surface

  return !el1?.id ||
    (el1?.total_surface !== '0.00' && el1?.total_surface !== undefined) ||
    (el2?.total_surface !== '0.00' && el2?.total_surface !== undefined) ||
    (el3?.total_surface !== '0.00' && el3?.total_surface !== undefined) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-roofed-surface">
        <th
          colSpan={2}
          className="text-center"
        >
          Sup. total
        </th>
      </tr>
      <tr className="tr-d-roofed-surface">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Sup. total
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && max === parseInt(el1?.total_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el1?.total_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && (
            <p className={`${parseInt(el1?.total_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el1?.total_surface) === 0
                ? 'No especificado'
                : parseInt(el1?.total_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && max === parseInt(el2?.total_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el2?.total_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1?.id && !el2?.id && <p>-</p>}
          {el2?.id && (
            <p className={`${parseInt(el2?.total_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el2?.total_surface) === 0
                ? 'No especificado'
                : parseInt(el2?.total_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && max === parseInt(el3?.total_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el3?.total_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2?.id && !el3?.id && <p>-</p>}
          {el3?.id && (
            <p className={`${parseInt(el3?.total_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el3?.total_surface) === 0
                ? 'No especificado'
                : parseInt(el3?.total_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const RoofedSurfaceTr = (el1: any, el2: any, el3: any, roofed: any) => {
  const max = roofed
  const disabled =
    (el1?.roofed_surface === el2?.roofed_surface && el1?.roofed_surface === el3?.roofed_surface) ||
    !el2?.roofed_surface

  return !el1?.id ||
    (el1?.roofed_surface !== '0.00' && el1?.roofed_surface !== undefined) ||
    (el2?.roofed_surface !== '0.00' && el2?.roofed_surface !== undefined) ||
    (el3?.roofed_surface !== '0.00' && el3?.roofed_surface !== undefined) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-roofed-surface">
        <th
          colSpan={2}
          className="text-center"
        >
          Sup. cubierta
        </th>
      </tr>
      <tr className="tr-d-roofed-surface">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Sup. cubierta
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && max === parseInt(el1?.roofed_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el1?.roofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && (
            <p className={`${parseInt(el1?.roofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el1?.roofed_surface) === 0
                ? 'No especificado'
                : parseInt(el1?.roofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && max === parseInt(el2?.roofed_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el2?.roofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1?.id && !el2?.id && <p>-</p>}
          {el2?.id && (
            <p className={`${parseInt(el2?.roofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el2?.roofed_surface) === 0
                ? 'No especificado'
                : parseInt(el2?.roofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && max === parseInt(el3?.roofed_surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el3?.roofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2?.id && !el3?.id && <p>-</p>}
          {el3?.id && (
            <p className={`${parseInt(el3?.roofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el3?.roofed_surface) === 0
                ? 'No especificado'
                : parseInt(el3?.roofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const SemiRoofedSurfaceTr = (el1: any, el2: any, el3: any, semiroofed: any) => {
  const max = semiroofed
  const disabled =
    el1?.semiroofed_surface === el2?.semiroofed_surface &&
    el1?.semiroofed_surface === el3?.semiroofed_surface
  return !el1?.id ||
    el1?.semiroofed_surface > 0 ||
    el2?.semiroofed_surface > 0 ||
    el3?.semiroofed_surface > 0 ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-semiroofed-surface">
        <th
          colSpan={2}
          className="text-center"
        >
          Sup. semicubierta
        </th>
      </tr>
      <tr className="tr-d-semiroofed-surface">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Sup. semicubierta
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && max !== 0 && max === parseInt(el1?.semiroofed_surface)
              ? ' featured-cell-print'
              : '')
          }
        >
          {!disabled && max !== 0 && max === parseInt(el1?.semiroofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && (
            <p className={`${parseInt(el1?.semiroofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el1?.semiroofed_surface) === 0
                ? 'No especificado'
                : parseInt(el1?.semiroofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && max !== 0 && max === parseInt(el2?.semiroofed_surface)
              ? ' featured-cell-print'
              : '')
          }
        >
          {!disabled && max !== 0 && max === parseInt(el2?.semiroofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1?.id && !el2?.id && <p>-</p>}
          {el2?.id && (
            <p className={`${parseInt(el2?.semiroofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el2?.semiroofed_surface) === 0
                ? 'No especificado'
                : parseInt(el2?.semiroofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && max !== 0 && max === parseInt(el3?.semiroofed_surface)
              ? ' featured-cell-print'
              : '')
          }
        >
          {!disabled && max !== 0 && max === parseInt(el3?.semiroofed_surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2?.id && !el3?.id && <p>-</p>}
          {el3?.id && (
            <p className={`${parseInt(el3?.semiroofed_surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el3?.semiroofed_surface) === 0
                ? 'No especificado'
                : parseInt(el3?.semiroofed_surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
} // Falta terminar de revisar

export const SurfaceTr = (el1: any, el2: any, el3: any, surface: any) => {
  const max = surface
  const disabled = (el1?.surface === el2?.surface && el1?.surface === el3?.surface) || !el2
  return !el1?.id ||
    (el1?.surface !== '0.00' && el1?.surface !== undefined) ||
    (el2?.surface !== '0.00' && el2?.surface !== undefined) ||
    (el3?.surface !== '0.00' && el3?.surface !== undefined) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-surface">
        <th
          colSpan={2}
          className="text-center"
        >
          Sup. terreno
        </th>
      </tr>
      <tr className="tr-d-surface">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Sup. terreno
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && max === parseInt(el1?.surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el1?.surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && (
            <p className={`${parseInt(el1?.surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el1?.surface) === 0
                ? 'No especificado'
                : parseInt(el1?.surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && max === parseInt(el2?.surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el2?.surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1?.id && !el2?.id && <p>-</p>}
          {el2?.id && (
            <p className={`${parseInt(el2?.surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el2?.surface) === 0
                ? 'No especificado'
                : parseInt(el2?.surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && max === parseInt(el3?.surface) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max === parseInt(el3?.surface) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2?.id && !el3?.id && <p>-</p>}
          {el3?.id && (
            <p className={`${parseInt(el3?.surface) === 0 ? 'uninformed' : ''}`}>
              {parseInt(el3?.surface) === 0
                ? 'No especificado'
                : parseInt(el3?.surface) + ' m2' || 'No especificado'}
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const EnvironmentTr = (el1: Property, el2: Property, el3: Property, environment: any) => {
  const disabled =
    (el1?.room_amount === el2?.room_amount && el1?.room_amount === el3?.room_amount) || !el2
  return !el1?.id || el1?.room_amount > 0 || el2?.room_amount > 0 || el3?.room_amount > 0 ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-environment">
        <th
          colSpan={2}
          className="text-center"
        >
          Ambientes
        </th>
      </tr>
      <tr className="tr-d-environment">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Ambientes
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && environment === el1?.room_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && environment === el1?.room_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && <p>{getEnvironment(el1)}</p>}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && environment === el2?.room_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && environment === el2?.room_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el2?.id && el1?.id && <p>-</p>}
          {el2?.id && <p>{getEnvironment(el2)}</p>}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && environment === el3?.room_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && environment === el3?.room_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el3?.id && el2?.id && <p>-</p>}
          {el3?.id && <p>{getEnvironment(el3)}</p>}
        </td>
      </tr>
    </>
  ) : (
    ''
  )
}

export const RoomsTr = (el1: Property, el2: Property, el3: Property, room: any) => {
  const disabled =
    (el1?.suite_amount === el2?.suite_amount && el1?.suite_amount === el3?.suite_amount) || !el2
  // const disabled = false
  return !el1?.id || el1?.suite_amount > 0 || el2?.suite_amount > 0 || el3?.suite_amount > 0 ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-rooms">
        <th
          colSpan={2}
          className="text-center"
        >
          Dormitorios
        </th>
      </tr>
      <tr className="tr-d-rooms">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Dormitorios
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && room === el1?.suite_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && room === el1?.suite_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && <p>{getRooms(el1)}</p>}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && room === el2?.suite_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && room === el2?.suite_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el2?.id && el1?.id && <p>-</p>}
          {el2?.id && <p>{getRooms(el2)}</p>}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && room === el3?.suite_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && room === el3?.suite_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el3?.id && el2?.id && <p>-</p>}
          {el3?.id && <p>{getRooms(el3)}</p>}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const BathroomsTr = (el1: Property, el2: Property, el3: Property, bathroms: any) => {
  const disabled =
    (el1?.bathroom_amount === el2?.bathroom_amount &&
      el1?.bathroom_amount === el3?.bathroom_amount) ||
    !el2
  // const disabled = false
  return !el1?.id ||
    el1?.bathroom_amount > 0 ||
    el2?.bathroom_amount > 0 ||
    el3?.bathroom_amount > 0 ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-rooms">
        <th
          colSpan={2}
          className="text-center"
        >
          Baños
        </th>
      </tr>
      <tr className="tr-d-rooms">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Baños
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && bathroms === el1?.bathroom_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && bathroms === el1?.bathroom_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && <p>{getBathrooms(el1)}</p>}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && bathroms === el2?.bathroom_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && bathroms === el2?.bathroom_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el2?.id && el1?.id && <p>-</p>}
          {el2?.id && <p>{getBathrooms(el2)}</p>}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && bathroms === el3?.bathroom_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && bathroms === el3?.bathroom_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el3?.id && el2?.id && <p>-</p>}
          {el3?.id && <p>{getBathrooms(el3)}</p>}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const ToiletsTr = (el1: Property, el2: Property, el3: Property, toilets: any) => {
  const disabled =
    (el1?.toilet_amount === el2?.toilet_amount && el1?.toilet_amount === el3?.toilet_amount) || !el2
  // const disabled = false
  return !el1?.id || el1?.toilet_amount > 0 || el2?.toilet_amount > 0 || el3?.toilet_amount > 0 ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-rooms">
        <th
          colSpan={2}
          className="text-center"
        >
          Toilettes
        </th>
      </tr>
      <tr className="tr-d-rooms">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Toilettes
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && toilets === el1?.toilet_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && toilets === el1?.toilet_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && <p>{getToilets(el1)}</p>}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && toilets === el2?.toilet_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && toilets === el2?.toilet_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el2?.id && el1?.id && <p>-</p>}
          {el2?.id && <p>{getToilets(el2)}</p>}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && toilets === el3?.toilet_amount ? ' featured-cell-print' : '')
          }
        >
          {!disabled && toilets === el3?.toilet_amount && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {!el3?.id && el2?.id && <p>-</p>}
          {el3?.id && <p>{getToilets(el3)}</p>}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const AgeTr = (el1: Property, el2: Property, el3: Property, age: any) => {
  const disabled = (el1?.age === el2?.age && el1?.age === el3?.age) || !el2
  const max = age
  return (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-age">
        <th
          colSpan={2}
          className="text-center"
        >
          Antigüedad
        </th>
      </tr>
      <tr className="tr-d-age">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Antigüedad
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && max?.toString() === el1?.age?.toString() ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max?.toString() === el1?.age?.toString() ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {!el1?.id && <p>-</p>}
          {el1?.id && (
            <p className={`${getAge(el1) === 'No informado' ? 'uninformed' : ''}`}>{getAge(el1)}</p>
          )}
        </td>
        <td
          className={
            'position-relative' +
            (!disabled && max?.toString() === el2?.age?.toString() ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max?.toString() === el2?.age?.toString() ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {!el2?.id && el1?.id && <p>-</p>}
          {el2?.id && (
            <p className={`${getAge(el2) === 'No informado' ? 'uninformed' : ''}`}>{getAge(el2)}</p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && max?.toString() === el3?.age?.toString() ? ' featured-cell-print' : '')
          }
        >
          {!disabled && max?.toString() === el3?.age?.toString() ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {!el3?.id && el2?.id && <p>-</p>}
          {el3?.id && (
            <p className={`${getAge(el3) === 'No informado' ? 'uninformed' : ''}`}>{getAge(el3)}</p>
          )}
        </td>
      </tr>
    </>
  )
}

export const BarbacueTr = (el1: Property, el2: Property, el3: Property) => {
  const disabled = (hasBarbacue(el1) && hasBarbacue(el2) && hasBarbacue(el3)) || !el2
  return hasBarbacue(el1) || hasBarbacue(el2) || hasBarbacue(el3) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-barbacue">
        <th
          colSpan={2}
          className="text-center"
        >
          Parrilla
        </th>
      </tr>
      <tr className="tr-d-barbacue">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Parrilla
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && hasBarbacue(el1) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasBarbacue(el1) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1 && (
            <p>
              <span className={hasBarbacue(el1) ? 'icon-check-light' : 'icon-close-light'}></span>
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' + (!disabled && hasBarbacue(el2) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasBarbacue(el2) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2 && (
            <p>
              <span className={hasBarbacue(el2) ? 'icon-check-light' : 'icon-close-light'}></span>
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && hasBarbacue(el3) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasBarbacue(el3) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el3 && (
            <p>
              <span className={hasBarbacue(el3) ? 'icon-check-light' : 'icon-close-light'}></span>
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const PoolTr = (el1: Property, el2: Property, el3: Property) => {
  const disabled = (hasPool(el1) && hasPool(el2) && hasPool(el3)) || !el2
  return hasPool(el1) || hasPool(el2) || hasPool(el3) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-pool">
        <th
          colSpan={2}
          className="text-center"
        >
          Pileta
        </th>
      </tr>
      <tr className="tr-d-pool">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          Pileta
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && hasPool(el1) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasPool(el1) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el1 && (
            <p>
              {hasPool(el1) ? (
                <span className="icon-check-light"></span>
              ) : (
                <span className="icon-close-light"></span>
              )}
            </p>
          )}
        </td>
        <td
          className={
            'position-relative' + (!disabled && hasPool(el2) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasPool(el2) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el2 && (
            <p>
              {hasPool(el2) ? (
                <span className="icon-check-light"></span>
              ) : (
                <span className="icon-close-light"></span>
              )}
            </p>
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && hasPool(el3) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasPool(el3) && (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          )}
          {el3 && (
            <p>
              {hasPool(el3) ? (
                <span className="icon-check-light"></span>
              ) : (
                <span className="icon-close-light"></span>
              )}
            </p>
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}

export const TagTr = (el1: Property, el2: Property, el3: Property, tag: any) => {
  const disabled = (hasTag(el1, tag.id) && hasTag(el2, tag.id) && hasTag(el3, tag.id)) || !el2
  return !el1 || hasTag(el1, tag.id) || hasTag(el2, tag.id) || hasTag(el3, tag.id) ? (
    <>
      <tr className="d-xs-table-row d-sm-none tr-m-tag">
        <th
          colSpan={2}
          className="text-center"
        >
          {tag.name}
        </th>
      </tr>
      <tr className="tr-d-tag">
        <th
          scope="row"
          className="d-none d-sm-table-cell first-cell"
        >
          {tag.name}
        </th>
        <td
          className={
            'position-relative first-column' +
            (!disabled && hasTag(el1, tag.id) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasTag(el1, tag.id) ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {el1?.id ? (
            <p className="d-flex align-items-center">
              {hasTag(el1, tag.id) ? (
                <span className="icon-check-light" />
              ) : (
                <span className="icon-close-light" />
              )}
            </p>
          ) : (
            '-'
          )}
        </td>
        <td
          className={
            'position-relative' + (!disabled && hasTag(el2, tag.id) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasTag(el2, tag.id) ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {el2?.id ? (
            <p className="d-flex align-items-center">
              {hasTag(el2, tag.id) ? (
                <span className="icon-check-light" />
              ) : (
                <span className="icon-close-light" />
              )}
            </p>
          ) : (
            ''
          )}
        </td>
        <td
          className={
            'd-none d-lg-table-cell' +
            ' position-relative' +
            (!disabled && hasTag(el3, tag.id) ? ' featured-cell-print' : '')
          }
        >
          {!disabled && hasTag(el3, tag.id) ? (
            <img
              className="featured-icon"
              src={FeaturedSVG}
            />
          ) : (
            ''
          )}
          {el3?.id ? (
            <p className="d-flex align-items-center">
              {hasTag(el3, tag.id) ? (
                <span className="icon-check-light" />
              ) : (
                <span className="icon-close-light" />
              )}
            </p>
          ) : (
            ''
          )}
        </td>
      </tr>
    </>
  ) : (
    <></>
  )
}
